import { useCallback } from 'react';
import { gql, useMutation } from '@apollo/client';
import { useStoreValue } from 'store';
import { useErrorTrackingAndUpdateStore } from './useErrorTrackingAndUpdateStore';

export const UPDATE_DVS_CONSENT_GQL = gql`
  mutation updateDVSConsent($input: UpdateDVSConsentInput!) {
    updateDVSConsent(input: $input) {
      status
    }
  }
`;

export function useUpdateDVSConsent() {
  const [storeState] = useStoreValue();
  const { applicationId } = storeState;
  const { handleErrorCallback } = useErrorTrackingAndUpdateStore('hook:updateDVSConsent');
  const [mutate, { loading }] = useMutation(UPDATE_DVS_CONSENT_GQL, {
    onError: err => {
      handleErrorCallback(err);
    },
  });

  const sendRequest = useCallback(
    async values => {
      const input = { applicationId, ...values };
      const result = await mutate({ variables: { input } });
      return result.data.updateDVSConsent;
    },
    [applicationId, mutate],
  );

  return {
    sendRequest,
    loading,
  };
}
